import { ApiType } from "@gymflow/common";
import { useMutation } from "@tanstack/react-query";

export const useMutationCreateAccount = ({ api }: { api: ApiType }) => {
  return useMutation({
    mutationFn: async (
      values: Parameters<
        ApiType["public"]["userMemberApi"]["createAccount"]
      >[0],
    ) => {
      return (await api.public.userMemberApi.createAccount(values)).data;
    },
  });
};
